<template>
  <div>
    <div id="particles-bg">
      <particles-bg color="#f7941e" num="7" type="cobweb" :bg="true" />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <h1>{{ this.contents.find(content => content.id_content === 161)?.title  }}</h1>
          <p id="city"><b>Porto</b></p>
          <p id="street">
            Rua da Alegria, nº 1988, <br />
            1º andar 4200-024 Porto
          </p>

          <p id="tlf">
            Phone Number: +351 22 017 8817 <br />
            Email: geral@nearcodeconsulting.com
          </p>

          <p>
            <a
              href="https://www.google.com/maps/place/NEARCODE+Consulting/@41.1639817,-8.5990379,15z/data=!4m5!3m4!1s0x0:0x7308396eb7205355!8m2!3d41.1639817!4d-8.5990379"
              target="blank"
              id="direction"
              ><u>{{ this.contents.find(content => content.id_content === 162)?.title  }}</u></a
            >
          </p>
        </div>
        <div class="col-sm-7">
          <a
            href="https://www.google.com/maps/place/NEARCODE+Consulting/@41.1639817,-8.5990379,15z/data=!4m5!3m4!1s0x0:0x7308396eb7205355!8m2!3d41.1639817!4d-8.5990379"
            target="blank"
          >
            <img src="../assets/Maps.png" id="Map" alt=""
          /></a>
          <!-- <Map></Map> -->
        </div>
      </div>
    </div>

    <img class="circle" src="../assets/circle.svg" alt="" />
    <FormContacts :contents="contents"></FormContacts>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../components/Footer";
import FormContacts from "../components/FormContacts";
/* import Map from "../components/Map"; */
import { ParticlesBg } from "particles-bg-vue";
import {mapGetters} from "vuex";
export default {
  name: "Contacts",
  components: {
    FormContacts,
    Footer,
    ParticlesBg,
  },
  data: function() {
    return {
      contents: [],
    };
  },
  mounted() {
    this.getAllContent();
  },
  methods : {
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page === 5) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({ name: "Error" });
      }
    }
  },
  computed: {
    ...mapGetters(["getContent"]),
  },
};
</script>

<style scoped>
.container {
  padding: 80px 50px 0px 50px;
}
h1 {
  font-family: "Barlow", sans-serif;
  font-weight: 500;
}
p {
  font-size: 20px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}
#city {
  font-size: 25px;
  font-weight: 500;
  color: #f7941e;
}
.circle {
  padding: 150px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
#direction {
  color: black;
  font-size: 23px;
}
u {
  text-decoration-line: underline;
  text-decoration-color: #f7941e;
}
#build {
  width: 100%;
  height: 300px;
  object-fit: none;
}
#particles-bg {
  position: fixed;
  /* fill the entire page */
  width: 100%;
  height: 100%;
  /* remove the space along the edges */
  margin: 0;
  padding: 0;
  /* position it to start at the top of the page */
  top: 0;
  /* put it behind other content */
  z-index: -1;
}
#Map {
  max-width: 100%;
  height: 300px;
  border: #f7951e96 2px solid;
}
@media (max-width: 1000px) {
  .circle {
    padding: 70px;
  }
  #Map {
    max-width: 100%;
    height: 150px;
    border: #f7951e96 2px solid;
  }
}
</style>
